import { createSlice } from "@reduxjs/toolkit";
import { sortTypes } from "../../assets/constants/constant";

const addToCartFn = () => {
  let cart = localStorage.getItem("cart");
  if (cart && cart.length > 0) {
    return JSON.parse(localStorage.getItem("cart"));
  } else {
    return [];
  }
};

const initialState = {
  cart: addToCartFn(),
  total_items: 0,
  total_amount: 0,
  shipping_fee: 200,
  isLoading: false,
};
const userCart = createSlice({
  name: "userCart",
  initialState,
  reducers: {
    addToCartProductSuccess: (state, action) => {
      const {
        categoryId,
        categoryName,
        name,
        price,
        productId,
        productImage,
        productWeight,
        stock,
        amount,
      } = action.payload;
      const cartState = [...state.cart];
      const tempItem = cartState.find((i) => i.productId === productId); /// item.name to productId and current using name

      if (tempItem) {
        const tempCart = cartState.map((cartItem) => {
           
          if (cartItem.productId === productId) {
            /// item.name to productId and current using name
            let newAmount = cartItem.amount + amount;
           //hear cheack stcok 
            if (newAmount > cartItem.stock) {
              newAmount = cartItem.stock;
            }
 
            return { ...cartItem, amount: newAmount };
          } else {
            return cartItem;
          }
        });
        state.cart = tempCart;
       
      } else {
        const newItem = {
          categoryId: categoryId,
          categoryName: categoryName,
          name: name,
          price: price,
          productId: productId,
          productImage: productImage,
          productWeight: productWeight,
          amount: amount,
          stock : stock
        };
        
        state.cart = [...state.cart, newItem];
      } 
    },

    removeCartSuccess: (state, action) => {
      const cartState = [...state.cart];
      const tempCart = cartState.filter((item) => item.productId !== action.payload); /// item.name to productId and current using name
      state.cart = tempCart;
    },
    clearCartSuccess: (state, action) => {
      state.cart = [];
    },
    toggleAmountSuccess: (state, action) => {
      const { id, value } = action.payload;
      let amountToggle = [...state.cart];
      const newCartValue = amountToggle.map((item) => {
        if (item.productId === id) {  /// item.name to productId and current using name
          if (value === sortTypes?.incriment) {
            let newAmount = item.amount + 1;
            if (newAmount > item.stock) {
              newAmount = item.stock;
            }
            return { ...item, amount: newAmount };
          }
          if (value === sortTypes?.decriment) {
            let newAmount = item.amount - 1;
            if (newAmount < 1) {
              newAmount = 1;
            }
            return { ...item, amount: newAmount };
          }
        }
        return item;
      });
      return {
        ...state,
        cart: newCartValue,
      };
    },
    cartTotalsSuccess: (state, action) => {
      const cart_checkout = [...state.cart];
      const { total_items, total_amount } = cart_checkout.reduce(
        (total, cartItem) => {
          const { amount, price } = cartItem;
          total.total_items += amount;
          total.total_amount += price * amount;
          return total;
        },
        {
          total_items: 0,
          total_amount: 0,
        }
      );
      state.total_items = total_items;
      state.total_amount = total_amount;
    },
  },
});

export const {
  addToCartProductSuccess,
  removeCartSuccess,
  clearCartSuccess,
  toggleAmountSuccess,
  cartTotalsSuccess,
} = userCart.actions;

export default userCart.reducer;
